var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"app-header"},[_c('TopNav',{attrs:{"title":_vm.siteTitle,"logo":_vm.siteLogo,"company-name":_vm.companyName}}),_c('AppMain',[_vm._t("default")],2)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }